import i18n, { PluginOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import sr from './sr.json';
import al from './al.json';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const options: PluginOptions<any> = {
    backend: {
        allowMultiLoading: false,
        loadPath: '/assets/locales/{{lng}}.json',
        // addPath: 'assets/locales/{{lng}}'
    }
};

i18n
    // .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: true,
        // backend: options.backend,
        react: {
            useSuspense: true
        },
        resources: {
            en: {
                translation: en
            },
            sr: {
                translation: sr
            },
            al: {
                translation: al
            }
        }
    });

export default i18n;
